import { FC } from "react";
import Section from "../Section";
import Button from "../Button";
import styles from "./CtaSection.module.scss";

export interface CtaButtonConfig {
  text: string;
  to?: string;
  href?: string;
  variant?: "primary" | "secondary" | "outline" | "outlineLight";
  size?: "sm" | "md" | "lg";
  onClick?: () => void;
}

interface CtaSectionProps {
  eyebrow?: string;
  heading: string;
  copy?: string;
  button: CtaButtonConfig;
  secondaryButton?: CtaButtonConfig;
}

const CtaSection: FC<CtaSectionProps> = ({
  eyebrow,
  heading,
  copy,
  button,
  secondaryButton,
}) => {
  return (
    <Section fullWidthContent bgColor="transparent" sectionClass={styles.ctaSection}>
      <div className={styles.banner}>
        <div className={styles.inner}>
          {eyebrow && <span className={styles.eyebrow}>{eyebrow}</span>}
          <h2 className={styles.heading}>{heading}</h2>
          {copy && <p className={styles.copy}>{copy}</p>}
          <div className={styles.actions}>
            <Button
              to={button.to}
              href={button.href}
              variant={button.variant || "secondary"}
              size={button.size || "lg"}
              onClick={button.onClick}
            >
              {button.text}
            </Button>
            {secondaryButton && (
              <Button
                to={secondaryButton.to}
                href={secondaryButton.href}
                variant={secondaryButton.variant || "outlineLight"}
                size={secondaryButton.size || "lg"}
                onClick={secondaryButton.onClick}
              >
                {secondaryButton.text}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Section>
  );
};

export default CtaSection;
